export default {
    en: {
        loginPage: {
            instructionstitle: 'Client Cabinet',
            instructionsLine1: 'Please log in, enter your trading account number and password that was sent to your e-mail.',
            instructionsLine2: 'At client cabinet you will be able to:',
        },
        loginBox: {
            email: 'Email',
            password: 'Password',
            submit: 'Access',
            forgot: 'Forgot password?'
        },
        consoleHeader: {
            account: 'Account #'
        },
    },
    es: {
        loginPage: {
            instructionsLine1: 'Por favor haz log in, introduce tu número de cuenta de trading y la contraseña que fue enviada a tu correo.',
            instructionsLine2: 'En el cabinet del cliente usted podrá:',
        },
        loginBox: {
            email: 'Correo electrónico',
            password: 'Contraseña',
            submit: 'Entrar',
            forgot: '¿Olvido la contraseña?'
        },
        consoleHeader: {
            account: 'Cuenta #'
        },
    }
}
